export type { CheckoutDeliveryAddress } from "@the-drop/customer-shared/address/types";
import type { CheckoutDeliveryAddress } from "@the-drop/customer-shared/address/types";

function storageKey(dispensarySlug: string): string {
  return `thedrop:cwa:checkout-delivery:${dispensarySlug}`;
}

export function readCheckoutDeliveryAddress(dispensarySlug: string): CheckoutDeliveryAddress | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(storageKey(dispensarySlug));
    if (!raw) return null;
    const v = JSON.parse(raw) as Partial<CheckoutDeliveryAddress>;
    if (
      typeof v.line1 === "string" &&
      typeof v.line2 === "string" &&
      typeof v.city === "string" &&
      typeof v.state === "string" &&
      typeof v.zip === "string" &&
      v.zip.length === 5
    ) {
      const out: CheckoutDeliveryAddress = {
        line1: v.line1,
        line2: v.line2,
        city: v.city,
        state: v.state,
        zip: v.zip,
      };
      if (typeof v.placeId === "string" && v.placeId.length > 0) {
        out.placeId = v.placeId;
      }
      return out;
    }
    return null;
  } catch {
    return null;
  }
}

export function writeCheckoutDeliveryAddress(
  dispensarySlug: string,
  address: CheckoutDeliveryAddress,
): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(storageKey(dispensarySlug), JSON.stringify(address));
  } catch {
    /* quota / private mode */
  }
}
